import { Box, IconButton, Input, Stack, Typography } from '@mui/material';
import { Button, useRefresh } from 'react-admin';
import { Controller, useForm } from 'react-hook-form';

import { AdminGetUserResponseDto } from 'api/generated';
import CloseIcon from '@mui/icons-material/Close';
import { api } from 'api';
import styled from 'styled-components';

interface Props {
  onCancel: () => void;
  record: AdminGetUserResponseDto;
}

type FormValues = {
  reason: string;
};

const UsersBanForm = ({ onCancel, record }: Props) => {
  const refresh = useRefresh();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      reason: '',
    },
  });
  const onSubmit = async (data: FormValues) => {
    try {
      if (record.isBlocked) {
        await api.V1AdminsUsersApi.adminUsersControllerUnblockUser(record.id, data);
        onCancel();
        refresh();
      } else {
        await api.V1AdminsUsersApi.adminUsersControllerBlockUser(record.id, data);
        onCancel();
        refresh();
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <Box pt={5} width={{ xs: '100vW', sm: 500 }} mt={{ xs: 2, sm: 1 }}>
      <Stack direction="row" p={2}>
        <Typography variant="h5" flex="1">
          {record.isBlocked ? 'Разблокировать' : 'Заблокировать'} пользователя
        </Typography>
        <IconButton onClick={onCancel} size="small">
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box p={5} mt={{ xs: 2, sm: 1 }}>
        <Typography variant="subtitle1" flex="1">
          Никнейм пользователя: {record.nickname}
        </Typography>
      </Box>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="reason"
          control={control}
          render={({ field }) => <Input placeholder="Укажите причину" {...field} multiline autoFocus />}
        />
        <Button type="submit" label="Подтвердить" color="secondary" />
      </StyledForm>
    </Box>
  );
};

export default UsersBanForm;

const StyledForm = styled.form`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
